module.exports = __webpack_public_path__ + "img/3.1f444238.png";